import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import api from '../../utils/api';
import DataTable from '../../components/ui/DataTable';
import StatusChip from '../../components/ui/StatusChip';

const ClientDispatches = () => {
  const [rows, setRows]       = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/dispatch')
      .then((r) => setRows(r.data.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const columns = [
    {
      label: 'Dispatch #', key: 'dispatchNumber',
      render: (r) => <span className="font-mono text-zip-red text-xs font-medium">{r.dispatchNumber}</span>,
    },
    { label: 'Consignee', key: 'consignee', render: (r) => r.consignee || '—' },
    {
      label: 'Items', key: 'items',
      render: (r) => <span className="font-mono text-zip-muted">{r.items?.length ?? 0}</span>,
    },
    { label: 'QC', key: 'qcStatus', render: (r) => <StatusChip status={r.qcStatus} /> },
    { label: 'Status', key: 'status', render: (r) => <StatusChip status={r.status} /> },
    {
      label: 'Date', key: 'createdAt',
      render: (r) => <span className="font-mono text-zip-muted text-xs">{format(new Date(r.createdAt), 'dd MMM yyyy')}</span>,
    },
  ];

  return (
    <div className="space-y-5">
      {loading ? (
        <div className="zip-card p-5 space-y-3">
          {[...Array(5)].map((_, i) => <div key={i} className="h-10 skeleton rounded" />)}
        </div>
      ) : (
        <DataTable columns={columns} rows={rows} emptyText="No dispatches recorded for your account." />
      )}
    </div>
  );
};

export default ClientDispatches;
